import type { NextPage } from "next";
import NextImage from "next/legacy/image";
import bg from "../assets/privacyDesktop.png";
import mobileBg from "../assets/privacyMobile.png";

import SEO from "../components/Seo/Seo";
import { CutoutAsset } from "../components/CutoutAsset/CutoutAsset";

const Privacy: NextPage = () => {
  return (
    <>
      <SEO title="Privacy Policy | Coinage Media" />
      <div className="roadmap-header flex h-[80vh] tab:h-[66vh] bg-coinage-teal relative overflow-hidden">
        <div className="hidden tab:flex absolute overflow-hidden z-0 right-0  w-2/3  h-full about-image-holder">
          <CutoutAsset image={bg} right={false} color="teal" />
        </div>

        <div className="tab:hidden absolute bottom-0 overflow-hidden z-0 right-0  w-full h-[66%] about-image-holder">
          <CutoutAsset image={mobileBg} mobile={true} color="teal" />
        </div>
        <div className=" flex mt-[60px] tab:mt-auto mb-auto z-1 relative mx-auto px-4 max-w-[1200px] w-full">
          <h1 className=" display1 text-coinage-white max-w-[720px]">
            PRIVACY
            <br />
            POLICY.
          </h1>
        </div>
      </div>

      <div className="bg-coinage-offWhite pt-20 pb-20">
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          GENERAL INFORMATION
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The information in this section is relevant to all categories of data
          subject.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          This includes:
        </p>

        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Users and Visitors
        </p>

        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Suppliers and Potential suppliers
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Trustless Media Inc., a Delaware corporation (including our
          subsidiaries, affiliates, “Trustless Media”, “we”, “us” or “our”) is
          responsible for your personal data submitted to or via trustless.media
          and coinage.media, and all affiliated sites, domains, subdomains,
          communications channels, addresses and directories (the “Sites”).
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You can contact a representative by sending an email to the following
          address: Contact@trustless.media
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Your rights
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the following rights:
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right to be informed
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the right to be informed about how Trustless Media processes
          your personal data. Typically, Trustless Media communicates this
          information through privacy notices such as this one.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right of data access
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have a right to obtain a copy of the personal data we hold about
          you, subject to certain exceptions.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right of data rectification
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You always have a right to ask for immediate correction of inaccurate
          or incomplete personal data which we hold about you.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right of data erasure
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the right to request that personal data be erased when it is
          no longer needed, where applicable law obliges us to delete the data
          or the processing of it is unlawful. You may also ask us to erase
          personal data where you have withdrawn your consent or objected to the
          data processing. However, this is not a general right to data erasure
          – there are exceptions and instances where data erasure is not
          possible, such as data submitted to public blockchains via interfaces
          on the Sites.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right to restrict data processing
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the right to restrict the processing of your personal data in
          specific circumstances. Where that is the case, we may still store
          your information, but not use it further.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right to data portability
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          The right to object to data processing
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the right to object to our processing of your personal data
          based on the legitimate interests, where your data privacy rights
          outweigh our reasoning for legitimate interests.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Rights in relation to automated decision making and profiling
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the right not to be subjected to a decision based solely on
          automated processing, including profiling, which produces legal or
          similarly significant effects. Currently, Trustless Media does not
          perform any automated decision making or profiling.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You may request to enforce your data privacy rights by
          emailing Contact@trustless.media
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          In certain circumstances, we may need to restrict the above rights to
          safeguard the public interest (e.g., the prevention or detection of
          crime) or our business interests (e.g., the maintenance of legal
          privilege).
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Consent as a legal basis for processing
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          For some data processing, Trustless Media uses consent as a legal
          basis. If you have consented to processing by Trustless Media, please
          be aware that you have the right to withdraw this consent at any
          point. If you would like to withdraw consent for a particular type of
          data processing that Trustless Media performs, please email the
          following address: Contact@trustless.media
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Complaints to a Supervisory Authority
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You have the right to lodge a complaint with a supervisory authority
          with regards to the way that Trustless Media processes your personal
          data. Trustless Media recommends lodging a complaint with the data
          protection authority officer/regulatory authority in the country in
          which you are a permanent resident.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          How we share your data
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We will not share your personal information with any third parties for
          the purposes of enhanced service experience or marketing. In some
          circumstances we are legally obliged to share information. For
          example, under a court order. In any scenario, we will satisfy
          ourselves that we have a lawful basis on which to share the
          information and document our decision making and satisfy ourselves we
          have a legal basis on which to share the information.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          How we protect your information
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We implement appropriate technical and organizational measures to
          protect personal data that we hold from unauthorized disclosure, use,
          alteration, or destruction. Where appropriate, we use encryption and
          other technologies that assist in securing the data you provide. We
          also require our service providers to comply with strict data privacy
          requirements where they process your personal data.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          How long we keep your personal data
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We only keep your personal data for as long as necessary for the
          purposes described in this privacy notice, or until you notify us that
          you no longer wish us to process your data. After this time, we will
          securely delete your personal data, unless we are required to keep it
          to meet legal or regulatory obligations, or to resolve potential legal
          disputes.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Contact and further information
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          If you have any questions about how we use your personal data or wish
          to make a complaint about how we handle it, you may contact Trustless
          Media at: Contact@trustless.media
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          USERS AND VISITORS
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Unsolicited Personal Information
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          If you send Trustless Media unsolicited personal information,
          Trustless Media reserves the right to immediately delete that
          information without informing you or to decide which category of data
          subject that you appear to be and manage your personal data within the
          remit of that category as described elsewhere in this Privacy Notice.
          We do not knowingly collect or solicit personal information from
          anyone under 18 years of age. If you are under 18, please do not send
          any personal information about yourself to us.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We collect the following categories of personal data:
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Any contact information you share with us: name, email address,
          pseudonym, telephone number, etc.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Information your browser makes available when you visit the Trustless
          Media website: IP address, public key and other externally-owned
          account information from your blockchain address and/or third party
          blockchain wallet provider or browser extension (for example,
          MetaMask), the source of your site visit, time spent on the website or
          a particular page, links clicked, comments shared, browser type, date
          and time of visit, etc.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] "></p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We use your personal data to: respond to your specific request that
          you make, for example request a demonstration, whitepapers,
          newsletters, or other information; conduct marketing and audience
          analysis activities (including generating leads, pursuing marketing
          prospects, performing market research, determining and managing the
          effectiveness of our advertising and marketing campaigns and managing
          our brand); and send you marketing communications (such as alerts,
          promotional materials, newsletters, etc.).
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We only collect the personal data from you that we need for the above
          purposes. We may also anonymize your personal data, so it no longer
          identifies you and use it for various purposes, including the
          improvement of our services and testing our IT systems.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We use your personal data for the purposes described in this notice
          based on legitimate interest, as by using our website it is understood
          that there is potential for you to be a potential user, contractor,
          employee, or supplier.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Copyright Violations
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We reserve the right to restrict access to or remove material that we
          believe in good faith to be copyrighted material and/or illegally
          copied and/or distributed, and restrict and discontinue service to
          offenders, to the extent we are reasonable able to do so. If you
          believe that material or content residing on or accessible through the
          Sites or Services infringes your copyright (or the copyright of
          someone on behalf of which you are authorized to act), please send a
          notice of copyright infringement containing the following information
          to Contact@trustless.media:
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          A signature of a person authorized to act on behalf of the owner of
          the copyright that has been allegedly infringed;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Identification of works or materials being infringed; and
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Evidence of the existing and allegedly infringed legal ownership.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          SUPPLIERS OR POTENTIAL SUPPLIERS
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We collect and use personal data that concerns you in connection with
          the agreements with our suppliers, contributors, and commercial
          participants. We may collect the following categories of personal
          data:
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Identification data and business contact information, you share with
          us such as name, job/position/title, email address, and telephone
          number.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          Additional information you provide to us in the course of our business
          relations such as data concerning the fulfilment of our contractual
          obligations and pre-contractual measures including correspondence
          data, offers, tenders, conditions, contract and order data, invoices,
          payments, blockchain externally-owned account address/public key,
          records relating to queries/questions/complaints/orders.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We may use your personal data as described above for the following
          purposes:
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          process and fulfilment of purchases, administration and management of
          suppliers, vendors, contractors, advisers and other professional
          experts;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          paying debts, invoice and payment management, purchasing of direct and
          indirect services;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          management of process quality, monitoring and auditing compliance with
          Trustless Media’s policies, contractual obligations and legal and
          statutory requirements;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          carrying out audits, reviews and regulatory checks to meet applicable
          obligations to regulators;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          governance, risk and compliance, including due diligence and
          anti-money laundering obligations, customs and global trade compliance
          and sanctioned party list screening, security, including prevention,
          detection of crime and fraud;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          maintain and protect the security of products, facilities, services,
          systems, networks, computers and information, preventing and detecting
          security threats, and fraud or other criminal or malicious activities;
          and
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          manage IT resources, including infrastructure management including
          data back-up, information systems’ support and service operations for
          application management, end user support, testing, maintenance,
          security (incident response, risk, vulnerability, breach response),
          user accounts management, software licenses assignment, security and
          performance testing and business continuity.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          We collect only the personal data from you that we need for the
          purposes described above. For statistical purposes, improvement of our
          services and testing of our IT systems we use as much as reasonably
          possible anonymized data. This means that these data can no longer
          (in)directly identify you or single you out as an individual. We may
          process your personal data for the fulfilment of contractual
          obligations resulting from contracts with you or your company, or as
          part of pre-contractual measures we take.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          In some cases, we rely on our legitimate interests to process your
          personal data insofar as this is not overridden by your own privacy
          interests. Such interests may include:
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          conduct, management, development and furtherance of our business in
          the broadest sense possible including supply of products and services,
          performance of agreements and order management with suppliers, process
          and fulfilment of purchases, process quality management and
          improvement of products or services, analytics and market
          intelligence, reduction of default risks in our procurement processes
          and reorganization, acquisition and sale of activities, business
          divisions and companies;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          monitor, investigate and ensure compliance with legal, regulatory,
          standard and Trustless Media internal requirements and policies;
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          prevent fraud and criminal activity including investigations of such
          activity, misuse of Trustless Media assets, products and services, and
          as strictly necessary and proportionate for ensuring network and
          information security; and
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          transmitting personal data within the Trustless Media group for
          internal administrative purposes as necessary for example to provide
          centralized services.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          In some cases, we process your personal data on the basis of legal
          obligations and statutory requirements, for example, on the basis of
          tax or reporting obligations, cooperation obligations with
          authorities, statutory retention periods or the disclosure of personal
          data within the scope of official or judicial measures may be required
          for the purposes of taking evidence, prosecution or enforcement of
          civil law claims.
        </p>
        <p className="body2 body-width ml-auto mr-auto mb-[30px] ">
          You may obtain a copy of our assessment of why we may process your
          personal data for these interests by submitting a request
          at Contact@trustless.media.
        </p>
      </div>
    </>
  );
};

export default Privacy;
